import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home/home.vue"
import RegionCheck from "../views/Home/regionCheck.vue"
import NotFound from "../views/NotFound/index.vue"
import Loading from "../views/Loading/loading.vue"
import Area from "../views/Area/index.vue"
import ScreenDisplay from "../views/ScreenDisplay/screenDisplay.vue"
import ScreenDisplaySin from "../views/ScreenDisplaySin/index.vue"
import NewScreen from "../views/bigScreen/index.vue"
import Index from "../views/Index/index.vue"
import Workbench from "../views/Index/Workbench/index.vue"
import Industry from "../views/Industry/index.vue"
import Invest from "../views/Invest/index.vue"
import Garden from "../views/Garden/index.vue"
import Company from "../views/Company/index.vue"
import ThematicLibrary from "../views/ThematicLibrary/index.vue"
import Product from "../views/Product/index.vue"
import Message from 'element-ui'
// import AreaOperation from "../views/Area/AreaOperation/index.vue"
// import Indicator from "../views/Area/Indicator/index.vue"

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);
let routes = [
  {
    path: "/",
    redirect: {
      name: "index"
    },
  },
  {
    path: "/loading",
    name: 'loading',
    component: Loading
  },
  {
    path: "/home",
    name: "home",
    component: Home
  },
  {
    path: "/regionCheck",
    name: "regionCheck",
    component: RegionCheck
  },

  {
    path: "/screenDisplay",
    name: "screendisplay",
    component: ScreenDisplay
  },
  {
    path: "/sinDisplay",
    name: "sinDisplay",
    component: ScreenDisplaySin
  },
  {
    path: "/newScreen",
    name: "newScreen",
    redirect: {
      name: 'areavue'
    },
    component: NewScreen,
    children: [{
      path: "/areavue",
      name: "areavue",
      component: () => import("../views/bigScreen/area/areaVue.vue")
    },
    {
      path: '/areason',
      name: 'areason',
      component: () => import("../views/bigScreen/area/areaSon.vue")
    },
    {
      path: '/industry',
      name: 'industry1',
      component: () => import("../views/bigScreen/trade/industry.vue")
    },
    {
      path: '/garden',
      name: 'garden1',
      component: () => import("../views/bigScreen/garden/garden.vue")
    },
    {
      path: '/project',
      name: 'project',
      component: () => import("../views/bigScreen/project/project.vue")
    }]
  },
  {
    path: "/index",
    redirect: {
      name: "workbench"
    },
    name: 'index',
    component: Index,
    children: [
      {
        path: "/index/workbench", //工作台
        name: "workbench",
        redirect: to => {
          let type = sessionStorage.getItem('userType')
          if (type) {
            if (type == 'yqyh') {
              return { path: '/index/workbench/mygarden' }
            } else if (type == 'zfyh' || type == 'gly') {
              return { path: "/index/workbench/government" }
            } else if (type == 'qyyh') {
              return { path: '/index/workbench/company' }
            } else {
              return { path: '/error' }
            }
          }
        },
        component: Workbench,
        children: [{
          path: "/index/workbench/government", //政府首页
          name: "government1",
          component: () => import("../views/Index/Workbench/Government/index.vue")
        },
        {
          path: "/index/workbench/company", //企业首页
          name: "companyIndex",
          component: () => import("../views/Index/Workbench/MyCompany/CompanyIndex.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/index/workbench/mycompany", //我的企业
          name: "mycompany",
          component: () => import("../views/Index/Workbench/MyCompany/MyCompany.vue"),
          meta: { requiresAuth: true }
        },
        {
          path: "/index/workbench/qysq",//企业信息
          name: "companyInformationZf1",
          component: () => import("../views/ThematicLibrary/CompanyInformation/qy/index.vue")
        },
        {
          path: "/index/workbench/mygarden", //我的园区
          name: "mygarden",
          component: () => import("../views/Index/Workbench/MyGarden/MyGarden.vue"),
          meta: { requiresAuth: true }
        },
        { //资金申报
          path: "/index/workbench/capitaldeclaration", //数据采集
          name: "capitaldeclaration",
          component: () => import("../views/Index/Workbench/CapitalDeclaration/index.vue"),
          // redirect: {
          //   name: "dataWrite"
          // }
        },

        { //数据采集
          path: "/index/workbench/dataCollection", //数据采集
          name: "dataCollection",
          component: () => import("../views/Index/Workbench/DataCollection/index.vue"),
          redirect: {
            name: "dataWrite"
          }
        },
        {
          path: "/index/workbench/dataWrite", //数据填报
          name: "dataWrite",
          component: () => import("../views/Index/Workbench/DataCollection/DataWrite/index.vue"),
        },
        {
          path: "/index/workbench/dataImport", //数据导入
          name: "dataImport",
          component: () => import("../views/Index/Workbench/DataCollection/DataImport/index.vue"),
        },
        {
          path: "/index/workbench/dataReplaceImport", //数据代填
          name: "dataReplaceImport",
          component: () => import("../views/Index/Workbench/DataCollection/DataReplaceImport/index.vue"),
        },


        { //报表管理
          path: "/index/workbench/reportManage", //报表管理
          name: "reportManage",
          redirect: {
            name: "reportModify"
          },
          component: () => import("../views/Index/Workbench/ReportManage/index.vue")
        },
        {
          path: "/index/workbench/reportModify", //申请修改
          name: "reportModify",
          component: () => import("../views/Index/Workbench/ReportManage/ReportModify/index.vue")
        },
        {
          path: "/index/workbench/reportExamine", //报表审核
          name: "reportExamine",
          component: () => import("../views/Index/Workbench/ReportManage/ReportExamine/index.vue")
        },
        {
          path: "/index/workbench/reportView", //报表查看
          name: "reportView",
          component: () => import("../views/Index/Workbench/ReportManage/ReportView/index.vue")
        },
        {
          path: "/index/workbench/reportStatistics", //报表统计 ==> 重定向到按地区
          name: "reportStatistics",
          redirect: {
            name: "regionClassify"
          },
          component: () => import("../views/Index/Workbench/ReportManage/ReportStatistics/index.vue")
        },
        {
          path: "/index/workbench/regionClassify", //按地区
          name: "regionClassify",
          component: () => import("../views/Index/Workbench/ReportManage/ReportStatistics/RegionClassify/index.vue")
        },
        {
          path: "/index/workbench/reportClassify", //按报表
          name: "reportClassify",
          component: () => import("../views/Index/Workbench/ReportManage/ReportStatistics/ReportClassify/index.vue")
        },
        {
          path: "/index/workbench/industryClassify", //按行业
          name: "industryClassify",
          component: () => import("../views/Index/Workbench/ReportManage/ReportStatistics/IndustryClassify/index.vue")
        },
        {
          path: "/index/workbench/cnterpriseClassify", //按企业注册类型
          name: "cnterpriseClassify",
          component: () => import("../views/Index/Workbench/ReportManage/ReportStatistics/CnterpriseClassify/index.vue")
        },


        { //系统管理
          path: "/index/workbench/systemManage", //系统管理 ==> 重定向到日志管理
          name: "systemManage",
          redirect: {
            name: "logManage"
          },
          component: () => import("../views/Index/Workbench/SystemManage/index.vue")
        },
        {
          path: "/index/workbench/logManage", //日志管理
          name: "logManage",
          component: () => import("../views/Index/Workbench/SystemManage/LogManage/index.vue")
        },
        {
          path: "/index/workbench/feedback", //问题反馈
          name: "feedback",
          component: () => import("../views/Index/Workbench/SystemManage/Feedback/index.vue")
        },
        {
          path: "/index/workbench/mapManage", //问题反馈
          name: "mapManage",
          component: () => import("../views/Index/Workbench/SystemManage/MapManage/index.vue")
        },
        {
          path: "/index/workbench/menuManage", //菜单管理
          name: "menuManage",
          component: () => import("../views/Index/Workbench/SystemManage/MenuManage/index.vue")
        },
        {
          path: "/index/workbench/deptManage", //部门管理
          name: "deptManage",
          component: () => import("../views/Index/Workbench/SystemManage/DeptManage/index.vue")
        },
        {
          path: "/index/workbench/roleManage", //角色管理
          name: "roleManage",
          component: () => import("../views/Index/Workbench/SystemManage/RoleManage/index.vue")
        },
        {
          path: "/index/workbench/userManage", //用户管理
          name: "userManage",
          component: () => import("../views/Index/Workbench/SystemManage/UserManage/index.vue")
        },
        {
          path: "/index/workbench/reportSetup", //报表设置
          name: "reportSetup",
          component: () => import("../views/Index/Workbench/SystemManage/ReportSetup/index.vue")
        },
        {
          path: "/index/workbench/codeManage", //代码管理
          name: "codeManage",
          redirect: {
            name: "industryCode"
          },
          component: () => import("../views/Index/Workbench/SystemManage/CodeManage/index.vue")
        },
        {
          path: "/index/workbench/industryCode", //行业代码
          name: "industryCode",
          component: () => import("../views/Index/Workbench/SystemManage/CodeManage/IndustryCode/index.vue")
        },
        {
          path: "/index/workbench/regionCode", //地区代码
          name: "regionCode",
          component: () => import("../views/Index/Workbench/SystemManage/CodeManage/RegionCode/index.vue")
        },
        {
          path: "/index/workbench/regCode", //地区代码
          name: "regCode",
          component: () => import("../views/Index/Workbench/SystemManage/CodeManage/RegCode/index.vue")
        },
        {
          path: "/index/workbench/productCode", //主要产品代码
          name: "productCode",
          component: () => import("../views/Index/Workbench/SystemManage/CodeManage/ProductCode/index.vue")
        },
        {
          path: "/index/workbench/valueAddedRate", //增加值率
          name: "valueAddedRate",
          component: () => import("../views/Index/Workbench/SystemManage/CodeManage/ValueAddedRate/index.vue")
        }

        ]
      },
      {
        path: "/index/area", //区域
        name: "area",
        component: Area,
        redirect: {
          name: "areaOperation"
        },
        children: [{
          path: "/index/area/areaOperation", //区域运行
          name: "areaOperation",
          component: () => import("../views/Area/AreaOperation/index.vue")
        },
        {
          path: "/index/area/indicator", //先行指标
          name: "indicator",
          component: () => import("../views/Area/Indicator/index.vue")
        }]
      },
      {
        path: "/index/invest", //投资
        name: "invest",
        redirect: {
          name: "investDataMonitor"
        },
        component: Invest,
        children: [
          {
            path: "/index/invest/investDataMonitor", //投资数据监测
            name: "investDataMonitor",
            component: () => import("../views/Invest/InvestDataMonitor/index.vue")
          }
        ]
      },
      {
        path: "/index/industry", //行业
        name: "industry",
        redirect: {
          name: "industryDataMonitor"
        },
        component: Industry,
        children: [
          {
            path: "/index/industry/industryDataMonitor", //行业数据监测
            name: "industryDataMonitor",
            component: () => import("../views/Industry/IndustryDataMonitor/index.vue")
          }
        ]
      },
      {
        path: "/index/garden", //园区
        name: "garden",
        redirect: {
          name: "gardenDataMonitor"
        },
        component: Garden,
        children: [
          {
            path: "/index/garden/gardenDataMonitor", //园区数据监测
            name: "gardenDataMonitor",
            component: () => import("../views/Garden/GardenDataMonitor/index.vue")
          },
          {
            path: "/index/garden/gardenBear", //园区数据监测
            name: "gardenBear",
            component: () => import("../views/Garden/GardenBear/index.vue")
          }
        ]
      },
      {
        path: "/index/company", //企业
        name: "company",
        redirect: {
          name: "companyDataMonitor"
        },
        component: Company,
        children: [
          {
            path: "/index/company/companyDataMonitor", //企业数据监测
            name: "companyDataMonitor",
            component: () => import("../views/Company/CompanyDataMonitor/index.vue")
          },
          {
            path: "/index/company/companyDataImport", //政府数据导入
            name: "companyDataImport",
            component: () => import("../views/Company/companyDataImport/index.vue")
          },
          {
            path: "/index/company/companyRisk", //企业风险监测
            name: "companyRisk",
            component: () => import("../views/Company/companyRisk/index.vue")
          },

          {
            path: "/index/company/enterpriseMap", //企业地图
            name: "enterpriseMap",
            component: () => import("../views/EnterpriseMap/index.vue")
          }
        ]
      },
      {
        path: "/index/product", //产品
        name: "product",
        redirect: {
          name: "productDataMonitor"
        },
        component: Product,
        children: [
          {
            path: "/index/product/productDataMonitor", //产品数据监测
            name: "productDataMonitor",
            component: () => import("../views/Product/ProductDataMonitor/index.vue")
          }
        ]
      },
      {
        path: "/index/thematicLibrary", //主题库
        name: "thematicLibrary",
        redirect: {
          name: "companyLibrary"
        },
        component: ThematicLibrary,
        children: [
          {
            path: "/index/thematicLibrary/companyLibrary", //企业库
            name: "companyLibrary",
            component: () => import("../views/ThematicLibrary/CompanyLibrary/index.vue")
          },
          {
            path: "/index/thematicLibrary/gardenLibrary", //园区库
            name: "gardenLibrary",
            component: () => import("../views/ThematicLibrary/GardenLibrary/index.vue")
          },
          {
            path: "/index/thematicLibrary/projectLibrary",//项目库
            name: "projectLibrary",
            component: () => import("../views/ThematicLibrary/ProjectLibrary/index.vue")
          },
          {
            path: "/index/zf/index",//企业信息
            name: "companyInformationZf",
            component: () => import("../views/ThematicLibrary/CompanyInformation/zf/index.vue")
          },
        ]
      }
    ]
  },
  {
    path: "**",
    component: NotFound
  },
  {
    path: "/error",
    component: NotFound
  }
];


const router = new VueRouter({
  routes
});

export default router;

